import React from "react"
import ReactDOM from "react-dom"
import MerchantFurtherInspiration from "./merchant-further-inspiration"

export default class MerchantFurtherInspirationModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.furtherInspirationLinks = elem.dataset.furtherInspirationLinks && JSON.parse(elem.dataset.furtherInspirationLinks)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<MerchantFurtherInspiration {...self.furtherInspirationLinks} />, self.elem)
  }
}
